export default "/images/878c9aa95515eaec4b31f1b7e07b1f31.jpg";